window.RS = {};
window.RS.reviews = (function() {
  const RATINGS_BASE_URL = 'https://api.trustpilot.com/v1/business-units';

   const star = function(dim) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${dim}" height="${dim}" viewBox="0 0 30 30" fill="currentColor"><path id="b" d="m15.02,1.53l3.18,10.08h10.8l-8.69,6.52,3.37,10.34-8.66-6.37-8.66,6.37,3.41-10.34L1,11.61h10.76L15.02,1.53Z"/></svg>`
  }
  const renderStars = function(num, dim) {
    let startMarkup = '';
    for ( let i=0; i < num; i++ ) {
      startMarkup = startMarkup.concat(`${star(dim)}`);
    }
    return startMarkup;
  }
  const renderStarsWidget = function(score, totalReviews, dim) {
    return `<div class="stars__wrapper">${renderStars(score, dim)}</span><span class="count__wrapper">(${totalReviews} reviews)</div>`;
  };
  const fetchData = async function(url) {
    let data = {};
    if (url) {
      const resp = await fetch(url).catch(e => { console.log(e) });
      data = resp && resp.ok ? await resp.json() : {};
    }
    return data;
  };

  return {
    productsReviews: new Map(),
    productsImportedReviews: new Map(),
    baseUrls: {
      ratings: RATINGS_BASE_URL
    },
    helpers: {
      fetchData,
      renderStars,
      renderStarsWidget,
      star
    }
  }
})();
window.RS.slickSlider = (function() {
  const arrow = '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="49" height="94" viewBox="0 0 100 100" fill="none"><path fill="#EA002B" fill-rule="evenodd" d="M48.09 46.089v1.295L6.65 93.649 0 87.41l36.14-39.967v-.825L.119 6.063 6.475 0 48.09 46.089Z" clip-rule="evenodd"/></svg>';
  const prevArrow = '<button type="button" class="slick-prev pull-left">' + arrow + '</button>';
  const nextArrow = '<button type="button" class="slick-next pull-right">' + arrow + '</button>';
  return {
    arrow,
    prevArrow,
    nextArrow
  }
})();
class TrustpilotProductReviewMini extends HTMLElement {
  constructor() {
    super();
    this.productReviewsUrl = '';
    this.productImportedReviewsUrl = '';
    this.productReviews = {};
    this.productImportedReviews = {};
  }
  connectedCallback() {
    this.pak = this.dataset.pak;
    this.sku = this.dataset.sku;
    this.businessunitId = this.dataset.businessunitId;
    this.style.color = this.dataset.starColor || 'currentColor';

    if (this.businessunitId && this.pak && this.sku) {
      this.productReviewsUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${this.dataset.businessunitId}?apikey=${this.dataset.pak}&stars=3,4,5&sku=${this.dataset.sku}&language=en-US`;
      this.productImportedReviewsUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${this.dataset.businessunitId}/imported-reviews-summaries?apikey=${this.dataset.pak}&stars=3,4,5&sku=${this.dataset.sku}&language=en-US`;
    }
    this.init();
  }
  get starsAverage() {
    const avgRegReviews = this.productReviews && this.productReviews.starsAverage;
    const avgImportedReviews = this.productImportedReviews && this.productImportedReviews.starsAverage;
    return ((avgRegReviews || 0) + (avgImportedReviews || 0)) / 2.0;
  }
  get totalReviews() {
    const totalRegReviews = this.productReviews && this.productReviews.numberOfReviews && this.productReviews.numberOfReviews.total;
    const totalImportedReviews = this.productImportedReviews && this.productImportedReviews.numberOfReviews && this.productImportedReviews.numberOfReviews.total;
    return (totalRegReviews || 0) + (totalImportedReviews || 0);
  }
  async init() {
    let cachedProductReviews = window.RS.reviews.productsReviews.get(this.sku) || await this._fetchProductReviewSummary(this.productReviewsUrl);
    let cachedProductImportedReviews = window.RS.reviews.productsImportedReviews.get(this.sku) || await this._fetchProductReviewSummary(this.productImportedReviewsUrl);

    this.productReviews = cachedProductReviews;
    this.productImportedReviews = cachedProductImportedReviews;
    this.renderWidget();
    if (!window.RS.reviews.productsReviews.get(this.sku) && cachedProductReviews) {
      window.RS.reviews.productsReviews.set(this.sku, cachedProductReviews);
    }
    if (!window.RS.reviews.productsImportedReviews.get(this.sku) && cachedProductImportedReviews) {
      window.RS.reviews.productsImportedReviews.set(this.sku, cachedProductImportedReviews);
    }
  }
  async _fetchProductReviewSummary(url) {
    let reviews = {};
    if (url) {
      const resp = await fetch(url).catch(e => { console.log(e) });
      reviews = resp && resp.ok ? await resp.json() : {};
    }
    return reviews || {};
  }
  renderWidget() {
    let html = '';
    if (this.starsAverage && this.totalReviews) {
      html = window.RS.reviews.helpers.renderStarsWidget(this.starsAverage, this.totalReviews, 14);
    }
    if (html) {
      this.innerHTML = html;
    }
  }
}
window.customElements.define("trustpilot-product-review-mini", TrustpilotProductReviewMini);

class SlideShow extends HTMLElement {
  constructor() {
    super();
    this.breakpoints = {
      desktop: 999
    }
    this.slickSettings = {
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      rows: 0,
      arrows: true,
      prevArrow: window.RS.slickSlider.prevArrow,
      nextArrow: window.RS.slickSlider.nextArrow,
      focusOnSelect: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: this.breakpoints.desktop,
          settings: {}
        }
      ]
    }

    const context = this;
    document.addEventListener('DOMContentLoaded', () => {
      context.init();
    });
    document.addEventListener('shopify:section:load', () => {
      context.init();
    });
  }
  init() {
    this.slides = this.querySelector('.slideshow__slide-list');
    if (this.slides && this.slides.childNodes && this.slides.childNodes.length > 1 && !this.slides.classList.contains('slick-initialized')) {
      const arrows = this.dataset.arrows === 'false' ? false : true;
      const arrowsMobile = this.dataset.arrowsMobile === 'false' ? false : true;
      this.slickSettings.arrows = arrowsMobile
      this.slickSettings.responsive.map(function(bp) {
        bp.settings.arrows = arrows;
        return bp;
      });
      this.slickSettings.autoplay = this.dataset.autoplay === 'true' ? true : false;
      this.slickSettings.autoplaySpeed = (this.dataset.autoplaySpeed || 3) * 1000;
      $(this.slides).slick(this.slickSettings);
    }
  }
}
window.customElements.define("slide-show", SlideShow);

(function() {
  // Dummy wrapper for store locator in the customizer
  class StoreLocator extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('store-locator', StoreLocator);
})();


document.addEventListener("DOMContentLoaded", function() {
  const CENTER_PADDING_MOBILE = '60px';
  const CENTER_PADDING = '100px';
  const SLICK_INITIALIZED_CLASS = 'slick-initialized';
  const breakpoints = {
    mobile: 480,
    tablet: 750,
    tabletL: 1024,
    desktop: 1440
  }
  const slickSettings = {
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    dots: false,
    rows: 0,
    arrows: true,
    prevArrow: window.RS.slickSlider.prevArrow,
    nextArrow: window.RS.slickSlider.nextArrow,
    focusOnSelect: true,
    mobileFirst: true,
    centerMode: false,
    centerPadding: CENTER_PADDING_MOBILE,
    responsive: [
      {
        breakpoint: breakpoints.tablet,
        settings: {
          slidesToShow: 1,
          variableWidth: true,
          centerMode: true,
          centerPadding: "50px"
        }
      },
      {
        breakpoint: breakpoints.desktop,
        settings: {
          slidesToShow: 2,
          variableWidth: true,
          centerMode: true,
          centerPadding: CENTER_PADDING
        }
      }
    ]
  }

  /* Products Carousel */
  const initProductSlider = () => {
    $('[data-module="slider"].products').each((i, elem) => {
      const $this = $(elem);
      if (!$this.hasClass(SLICK_INITIALIZED_CLASS)) {
        const arrows = $this.attr('data-arrows') === 'false' ? false : true;
        const arrowsMobile = $this.attr('data-arrows-mobile') === 'false' ? false : true;
        const productSlick = Object.assign({}, slickSettings);
        productSlick.arrows = arrowsMobile;

        productSlick.responsive.map(function(bp) {
          bp.settings.arrows = arrows;
          return bp;
        });
        $this.slick(productSlick);
      }
    });
  };

  /* Reviews Carousel */
  const initReviewsSlider = async () => {
    const reviewCard = function(corner, slot) {
      return `<div data-module="card" class="reviews corner__${corner}">${slot}</div>`
    }
    const reviewContent = function(data) {
      const { stars, text, consumer } = data;
      return `<div class="review">
        <div class="stars__wrapper">${window.RS.reviews.helpers.renderStars(stars, 34)}</div>
        <div class="review__content">${text}</div>
        <div class="review__user">${consumer?.displayName}</div>
      </div>`
    }
    const LIMIT = 5;
    const REVEAL = 'reveal';
    const $reviews = $('[data-module="slider"].reviews');
    const $section = $('[data-section-type="rs-carousel--reviews"]');
    const $subtitle = $('[data-section-type="rs-carousel--reviews"] .section-heading__subtitle');
    const $sliders = $('[data-module="slider"].new-reviews') || $('[data-module="slider"].reviews');
    const corner = $sliders.data('cardCorner');
    let ratingsData = window.spdRatings;

    if ( typeof ratingsData === 'undefined') {
      const businessunitId = $sliders.attr('data-businessunit-id');
      const pak = $sliders.attr('data-pak');
      if (businessunitId && pak) {
        const ratingsUrl = `${window.RS.reviews.baseUrls.ratings}/${businessunitId}`;
        const totalRatingsData = await window.RS.reviews.helpers.fetchData(`${ratingsUrl}?apikey=${pak}`);
        const reviewsData = await window.RS.reviews.helpers.fetchData(`${ratingsUrl}/reviews?apikey=${pak}&stars=4,5`);
        ratingsData = {
          ratings: totalRatingsData || {},
          reviews: reviewsData?.reviews || []
        };
      }
    };

    const totalReviews = ratingsData?.ratings?.numberOfReviews?.total;
    const score = ratingsData?.ratings?.score?.stars;
    const limit = Math.min(LIMIT, ratingsData?.reviews?.length);

    const subtitle = totalReviews && score ? window.RS.reviews.helpers.renderStarsWidget(score, totalReviews, 24) : '';

    $subtitle.html(subtitle).addClass(REVEAL);

    /*const slidersEl = (ratingsData?.reviews || []).map(function(review, index) {
      if ( index < limit ) {
        return reviewCard(corner, reviewContent(review));
      }
    }).join('');

    $sliders.html(slidersEl);*/

    $('[data-module="slider"].reviews').each((i, elem) => {
      const $this = $(elem);
      if (!$this.hasClass(SLICK_INITIALIZED_CLASS)) {
        const arrows = $this.attr('data-arrows') === 'false' ? false : true;
        const arrowsMobile = $this.attr('data-arrows-mobile') === 'false' ? false : true;
        const reviewsSlick = Object.assign({}, slickSettings);
        reviewsSlick.slidesToShow = 1;
        reviewsSlick.centerMode = false;
        reviewsSlick.autoplay = true,
        reviewsSlick.arrows = arrowsMobile;
        reviewsSlick.responsive.map(function(bp) {
          bp.settings.centerMode = true;
          bp.settings.arrows = arrows;
          return bp;
        });
        $this.slick(reviewsSlick);
      }
    });

    $('[data-module="slider"].new-reviews').each((i, elem) => {
      const $this = $(elem);
      if (!$this.hasClass(SLICK_INITIALIZED_CLASS)) {
        const arrows = $this.attr('data-arrows') === 'false' ? false : true;
        const arrowsMobile = $this.attr('data-arrows-mobile') === 'false' ? false : true;
        const reviewsSlick = Object.assign({}, slickSettings);
        reviewsSlick.slidesToShow = 1;
        reviewsSlick.centerMode = false;
        reviewsSlick.autoplay = true,
        reviewsSlick.arrows = arrowsMobile;
        reviewsSlick.responsive.map(function(bp) {
          bp.settings.centerMode = true;
          bp.settings.arrows = arrows;
          return bp;
        });
        $this.slick(reviewsSlick);
      }
    });
  };

  initProductSlider();
  initReviewsSlider();
  document.addEventListener('shopify:section:load', () => {
    initProductSlider();
    initReviewsSlider();
  });

  /* Store Locator Carousel */
  const locatorSettings = {
    lazyLoad: 'ondemand',
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    dots: false,
    rows: 0,
    arrows: false,
    focusOnSelect: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: breakpoints.mobile,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: breakpoints.tablet,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: breakpoints.tabletL,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: breakpoints.desktop,
        settings: "unslick"
      }
    ]
  }
  $('#store-locator .store-icon-container').slick(locatorSettings);
});